const vVisible = {
  install(Vue) {
    Vue.prototype._visible = true
    Vue.directive("visible", (el, binding, vnode) => {
      var value = binding.value

      if (value) {
        el.style.opacity = "1"
        vnode.context._invisible = false
      } else {
        el.style.opacity = "0"
        vnode.context._invisible = true
      }
    })
  }
}

export default vVisible
